import React from 'react';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import './confirmation-row.scss';

export type ConfirmationSectionVariant = 'internal' | 'external' | 'unchanged';

const resolveStateLabel = (variant: ConfirmationSectionVariant): string => {
  if (variant === 'internal') {
    return 'Now internal';
  }

  if (variant === 'external') {
    return 'Now external';
  }

  return 'No change';
};

interface ConfirmationRowProps {
  serviceRequest: IServiceRequest;
  variant: ConfirmationSectionVariant;
}

const ConfirmationRow = React.memo(
  ({ serviceRequest, variant }: ConfirmationRowProps) => {
    const ticketNumber: string =
      serviceRequest.ticketNumber ?? serviceRequest.number ?? '—';
    const subject: string = serviceRequest.subject?.trim() || 'No subject';

    const showColoredPill: boolean = variant !== 'unchanged';
    const stateLabel: string = resolveStateLabel(variant);
    const pillColor: string =
      variant === 'internal'
        ? 'var(--color-status-negative)'
        : 'var(--color-status-positive)';

    return (
      <div className="svc-row">
        <div className="svc-row-identity">
          <div className="svc-row-number">{ticketNumber}</div>
          <div className="svc-row-subject">{subject}</div>
        </div>

        <div className="svc-row-status">
          {serviceRequest.status && (
            <CategoryPill text={serviceRequest.status} size="small" />
          )}
        </div>

        <div className="svc-row-state">
          {showColoredPill ? (
            <CategoryPill
              text={stateLabel}
              color={pillColor}
              textColor="#fff"
              size="small"
            />
          ) : (
            <CategoryPill text="No change" size="small" />
          )}
        </div>
      </div>
    );
  }
);

ConfirmationRow.displayName = 'ConfirmationRow';

export default ConfirmationRow;